import { observable, action, computed, configure, runInAction } from 'mobx';
import { createContext } from 'react';
import { ISiteVodafone } from '../models/sitevodafone';
import { ITechnician } from '../models/technician';
import { toast } from 'react-toastify';
import agent from '../api/agent';


configure({enforceActions: 'always'});

class SiteVodafoneStore {
  @observable sitevodafoneRegistry = new Map();
  @observable sitevodafonehistoryRegistry = new Map();
  @observable sitevodafone: ISiteVodafone | null = null;
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = '';

  @computed get sitevodafonenamesByDate() {
    return Array.from(this.sitevodafoneRegistry.values()).sort(
      (a, b) => a.siteID_c.localeCompare(b.siteID_c));
  }

  @computed get sitevodafonehistoryByDate() {
    return Array.from(this.sitevodafonehistoryRegistry.values()).sort(
      (b, a) => Date.parse(a.updatedAt) - Date.parse(b.updatedAt)
    );
  }

  @action searchSiteVodafones = async (search : {siteId: string, siteName: string}) => {
    if (search.siteId === '' && search.siteName === '')
    {
      toast.info('Please put in at least one search condition');
      return;
    }
    const params = new URLSearchParams();
    params.append('siteId', search.siteId);
    params.append('siteName', search.siteName);

    this.loadingInitial = true;
    try {
      const sitevodafones = await agent.SiteVodafones.search(params);
      this.sitevodafoneRegistry.clear();
      runInAction('loading sitevodafones', () => {
        sitevodafones.forEach(sitevodafone => {
          this.sitevodafoneRegistry.set(sitevodafone.id, sitevodafone);
        });
        this.loadingInitial = false;
      })

    } catch (error) {
      runInAction('load Site Vodafone List error', () => {
        this.loadingInitial = false;
      })
      toast.error('load Site Vodafone List error');
    }
  };

  @action loadSiteVodafone = async (id: string) => {
      this.loadingInitial = true;
      try {
        var sitevodafone = await agent.SiteVodafones.details(id);
        runInAction('getting sitevodafone',() => {
          this.sitevodafone = sitevodafone;
          this.loadingInitial = false;
        })
      } catch (error) {
        runInAction('get sitevodafone error', () => {
          this.loadingInitial = false;
        })
        toast.error('get sitevodafone error');
        console.log(error);
      }
  }

  @action clearSiteVodafone = () => {
    this.sitevodafone = null;
  }

  getSiteVodafone = (id: string) => {
    return this.sitevodafoneRegistry.get(Number(id));
  }

  @action editSiteVodafone = async (sitevodafone: ISiteVodafone) => {
    this.submitting = true;
    try {
      await agent.SiteVodafones.update(sitevodafone);
      runInAction('editing sitevodafone', () => {
        this.sitevodafoneRegistry.set(sitevodafone.id, sitevodafone);
        this.sitevodafone = sitevodafone;
        this.submitting = false;
        toast.success('Site edit successful');
      })
    } catch (error) {
      runInAction('edit sitevodafone error', () => {
        this.submitting = false;
      })
      toast.error('edit sitevodafone error');
      console.log(error);
    }
  };

  @action deleteSiteVodafone = async (id: string) => {
    this.submitting = true;
    this.target = id;
    try {
      await agent.SiteVodafones.delete(id);
      runInAction('deleting SiteVodafone', () => {
        this.sitevodafoneRegistry.delete(id);
        this.submitting = false;
        this.target = '';
      })
    } catch (error) {
      runInAction('delete SiteVodafone error', () => {
        this.submitting = false;
        this.target = '';
      })
      toast.error('delete SiteVodafone error');
      console.log(error);
    }
  }

  @action loadSiteVodafoneHistory = async (siteVodafoneId: string) => {
    this.loadingInitial = true;
    try {
      const siteVodafoneHistorys = await agent.SiteVodafones.listhistory(siteVodafoneId);
      this.sitevodafonehistoryRegistry.clear();
      runInAction('loading site history', () => {
        siteVodafoneHistorys.forEach(siteVodafoneHistory => {
          this.sitevodafonehistoryRegistry.set(siteVodafoneHistory.id, siteVodafoneHistory);
        });
        this.loadingInitial = false;
      })
  
    } catch (error) {
      runInAction('load site history error', () => {
        this.loadingInitial = false;
      })
      toast.error('load site history error');
    }
  };

  @action selectHistory = (id: string) => {
    this.sitevodafone = null;
    var sitevodafonehistory = this.sitevodafonehistoryRegistry.get(Number(id));
    this.sitevodafone = {
      id: sitevodafonehistory.siteVodafoneId,
    createdAt: '',
    updatedAt: sitevodafonehistory.updatedAt,
    siteID_c: sitevodafonehistory.siteID_c,
    siteName: sitevodafonehistory.siteName,
    direct_Access: sitevodafonehistory.direct_Access,
    businessHoursSiteAccess: sitevodafonehistory.businessHoursSiteAccess,
    afterHoursSiteAccess: sitevodafonehistory.afterHoursSiteAccess,
    businessHoursEmergencySiteAccess: sitevodafonehistory.businessHoursEmergencySiteAccess,
    afterHoursEmergencySiteAccess: sitevodafonehistory.afterHoursEmergencySiteAccess,
    siteType: sitevodafonehistory.siteType,
    fopsData: sitevodafonehistory.fopsData,
    key_DirectAccess: sitevodafonehistory.key_DirectAccess,
    comments: sitevodafonehistory.comments,
    keyLocationAddress: sitevodafonehistory.keyLocationAddress,
    keySpecificDetails: sitevodafonehistory.keySpecificDetails,
    oH_SDetails: sitevodafonehistory.oH_SDetails,
    siteHazards: sitevodafonehistory.siteHazards,
    siteInductionRequired: sitevodafonehistory.siteInductionRequired,
    siteInductionContactName: sitevodafonehistory.siteInductionContactName,
    siteInductionContactNumber: sitevodafonehistory.siteInductionContactNumber,
    siteInductionContactEmail: sitevodafonehistory.siteInductionContactEmail,
    siteInductionDetails: sitevodafonehistory.siteInductionDetails,
    siteInductionOnlineTraining: sitevodafonehistory.siteInductionOnlineTraining,
    siteInductionOnlineTrainingURL: sitevodafonehistory.siteInductionOnlineTrainingURL,
    siteInductionValidityPeriod: sitevodafonehistory.siteInductionValidityPeriod,
    structureType: sitevodafonehistory.structureType,
    specialDetails: sitevodafonehistory.specialDetails,
    directions: sitevodafonehistory.directions,
    address: sitevodafonehistory.address,
    addressAdditional: sitevodafonehistory.addressAdditional,
    city: sitevodafonehistory.city,
    stateOrProvince: sitevodafonehistory.stateOrProvince,
    postalCode: sitevodafonehistory.postalCode,
    siteID_c2: sitevodafonehistory.siteID_c2,
    latitude: sitevodafonehistory.latitude,
    longitude: sitevodafonehistory.longitude,
    remark: sitevodafonehistory.remark,
    };
    

  }

}

export default createContext(new SiteVodafoneStore());
